<div class="mapfre code-block">
  <pre>
    <code>
      <ng-content></ng-content>
    </code>
  </pre>
</div>